import { ENV } from './env'
ENV.env = 'TEST'
export default ENV
